<script>
    import ElementPanel from "./ElementPanel.svelte";
    import ElementTable from "./ElementTable.svelte";
    import ElementText from "./ElementText.svelte";
    import ElementChart from "./ElementChart.svelte";
    import ElementReport from "./ElementReport.svelte";
    
    export let gridData; // grids[n]

    const columns = gridData.gridColumns ? gridData.gridColumns.length : 6;

    // console.log('Grid gridData', gridData, Date.now() );
    
</script>

<div class="grid" 
    style="grid-template-columns: repeat({columns}, 1fr);"
    >
    {#each gridData.gridContent as element}
        {#if element.type == 'panel'}
            <ElementPanel
                elementData = {element}
            />
            <!-- {console.log('ElementPanel elementData', element)} -->
        {/if}
        {#if element.type == 'text'}
            <ElementText
                elementData = {element}
            />
        {/if}
        {#if element.type == 'table'}
            <ElementTable
                elementData = {element}
            />
        {/if}
        {#if element.type == 'chart'}
            <ElementChart
                elementData = {element}
            />
            <!-- {console.log('ElementChart elementData', element)} -->
        {/if}
        {#if element.type == 'report'}
            <ElementReport
                elementData = {element}
            />
            <!-- {console.log('ElementReport elementData', element)} -->
        {/if}
    {/each}
</div>

<style>
    .grid {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 10px;
    }

</style>